import { render, staticRenderFns } from "./CardGerantListe.vue?vue&type=template&id=d1ed1c0c"
import script from "./CardGerantListe.vue?vue&type=script&lang=js"
export * from "./CardGerantListe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports